import { render, staticRenderFns } from "./EmailDomainVerificationEntry.vue?vue&type=template&id=a85d2a8e&scoped=true"
import script from "./EmailDomainVerificationEntry.vue?vue&type=script&lang=js"
export * from "./EmailDomainVerificationEntry.vue?vue&type=script&lang=js"
import style0 from "./EmailDomainVerificationEntry.vue?vue&type=style&index=0&id=a85d2a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85d2a8e",
  null
  
)

export default component.exports